import "./EasyCallMeComp.scss";
import React, { ChangeEvent } from "react";
import { Button, ButtonGroup, Grid, IconButton, TextField } from "@mui/material";
import VideocamIcon from "@mui/icons-material/Videocam";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MicIcon from "@mui/icons-material/Mic";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { withTranslation } from 'react-i18next';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import App, { InterfaceAppState, InterfaceEasyCallMeState } from "../../../App";
import { ValidateUtil } from "../../../utils/validate";
import { HelperUtil } from "../../../utils/helper";
import i18next from "i18next";

class EasyCallMeComp extends React.Component<any, {
    smallMode: boolean;
}> {
    constructor(props: any) {
        super(props);

        this.state = {
            smallMode: true
        };

    }

    // observer: ResizeObserver | null = null;

    render() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;
        const EasyCallMeState: InterfaceEasyCallMeState = this.props.AppState.EasyCallMe;
        const localCams = AppState.localCameras;
        const selectedCam = AppState.selectedCamera;
        const localMics = AppState.localMicrophones;
        const selectedMic = AppState.selectedMicrophone;
        const localSpks = AppState.localSpeakers;
        const selectedSpk = AppState.selectedSpeaker;
        const { t } = this.props;

        return (
            <>
                <div id="page-easy-call-me-pre-call" className={AppState.withStyle ? 'with-style' : ''}>
                    <Grid id={"easy-call-form-container"} container spacing={0} columns={20}>
                        <Grid className={'app-body'} item xs={this.state.smallMode ? 20 : 9}>
                            <div id="pre-call-form"
                                onKeyUp={event => {
                                    if (event.key === 'Enter') {
                                        this.enter();
                                    }
                                }}
                                className={(this.state.smallMode ? 'with-background ' : '') +
                                    (AppState.withStyle ? 'with-style ' : '')}>
                                {EasyCallMeState?.showAudioVideoSettings && <>
                                    <div>
                                        <p>{t('description_message')}</p>
                                    </div>
                                    <div className="div-main-control">
                                        <ButtonGroup variant="contained" aria-label="outlined disabled button group"
                                            className="button-group btn-main-control">
                                            <Button onClick={() => {
                                                if (AppState.audioOnly) {
                                                    AppComp.setAudioOnly(false, (value) => {
                                                        AppComp.initPreviewVideo();
                                                    });
                                                } else {
                                                    if (HelperUtil.showLogs()) {
                                                        console.log('Audio only mode will be used, selected microphone', selectedMic);
                                                    }
                                                    AppComp.setAudioOnly(true, (value) => {

                                                    });
                                                }
                                            }}
                                                className={AppState.audioOnly ? 'btn-main btn-select audio-only' : 'btn-main btn-select'}
                                                startIcon={!AppState.audioOnly ? <VideocamIcon /> :
                                                    <VideocamOffIcon />}
                                                variant="text">
                                                <div className="ellip">{selectedCam ? selectedCam.label : ''}</div>
                                            </Button>
                                            <CustomSelect data={localCams.map(cam => {
                                                return {
                                                    value: cam.deviceId,
                                                    text: cam.label,
                                                    selected: selectedCam && selectedCam.deviceId === cam.deviceId,
                                                    data: cam
                                                }
                                            })} getToggleButton={(onClick) => {
                                                // @ts-ignore
                                                return <Button onClick={onClick}
                                                    style={{ width: '40px' }}
                                                    className={AppState.audioOnly ? 'btn-select-arrow audio-only' : 'btn-select-arrow'}
                                                    variant="text"><KeyboardArrowDownIcon /></Button>
                                            }} onSelect={item => {
                                                AppComp.selectCamera(item.data, (selectedCamera) => {
                                                    if (selectedCamera) {
                                                        const constraints: MediaStreamConstraints = {
                                                            audio: false,
                                                            video: { deviceId: selectedCamera.deviceId }
                                                        };

                                                        AppComp.initPreviewVideo(constraints);
                                                    }
                                                });
                                            }} />
                                        </ButtonGroup>
                                    </div>
                                    <div className="div-main-control">
                                        <ButtonGroup variant="contained" aria-label="outlined primary button group"
                                            className="button-group btn-main-control">
                                            <Button startIcon={<MicIcon />} variant="text"
                                                className="btn-main btn-select">
                                                <div className="ellip">{selectedMic ? selectedMic.label : ''}</div>
                                            </Button>
                                            <CustomSelect data={localMics.map(mic => {
                                                return {
                                                    value: mic.deviceId,
                                                    text: mic.label,
                                                    selected: selectedMic && selectedMic.deviceId === mic.deviceId,
                                                    data: mic
                                                }
                                            })} getToggleButton={(onClick) => {
                                                // @ts-ignore
                                                return <Button onClick={onClick}
                                                    style={{ width: '40px' }}
                                                    className={'btn-select-arrow'}
                                                    variant="text"><KeyboardArrowDownIcon /></Button>
                                            }} onSelect={item => {
                                                AppComp.selectMicrophone(item.data, selectedMicrophone => {

                                                });
                                            }} />
                                        </ButtonGroup>
                                    </div>
                                    <div className="div-main-control">
                                        <ButtonGroup variant="contained" aria-label="outlined primary button group"
                                            className="button-group btn-main-control">
                                            {
                                                (AppState.speakerAvailable || (localSpks && localSpks.length)) ?
                                                    <>
                                                        <Button startIcon={<VolumeUpIcon />} variant="text"
                                                            className="btn-main btn-select">
                                                            <div
                                                                className="ellip">{selectedSpk ? selectedSpk.label : ''}</div>
                                                        </Button>
                                                        <CustomSelect data={localSpks.map(spk => {
                                                            return {
                                                                value: spk.deviceId,
                                                                text: spk.label,
                                                                selected: selectedSpk && selectedSpk.deviceId === spk.deviceId,
                                                                data: spk
                                                            }
                                                        })} getToggleButton={(onClick) => {
                                                            // @ts-ignore
                                                            return <Button onClick={onClick}
                                                                style={{ width: '40px' }}
                                                                className={'btn-select-arrow'}
                                                                variant="text"><KeyboardArrowDownIcon /></Button>
                                                        }} onSelect={item => {
                                                            AppComp.selectSpeaker(item.data, selectedSpeaker => {
                                                                AppComp.setupSpeakerVideo(selectedSpeaker, AppComp.audioOutgoing, () => {
                                                                }, () => {
                                                                });
                                                            });
                                                        }} />
                                                        {selectedSpk && <IconButton onClick={() => {
                                                            AppComp.testSpeaker(selectedSpk);
                                                        }} aria-label="test speaker" color="success" style={{
                                                            position: 'absolute',
                                                            right: '-48px',
                                                            top: '-4px'
                                                        }}
                                                            size="small">
                                                            <PlayCircleFilledIcon
                                                                style={{ backgroundColor: 'white', borderRadius: '100%' }}
                                                                fontSize="large" />
                                                        </IconButton>}
                                                    </>
                                                    :
                                                    <>
                                                        <Button startIcon={<VolumeUpIcon />} variant="outlined"
                                                            className="btn-main">
                                                            <div
                                                                className="ellip">{t('speaker_placeholder_default')}</div>
                                                        </Button>
                                                    </>
                                            }
                                        </ButtonGroup>
                                    </div>

                                    <br />

                                    {/*<canvas id="canvas-audio-visualizer" width={300} height={150}>
                                        Your browser does not support the canvas tag.
                                    </canvas>

                                    <audio id="audio-audio-visualizer" controls={false}>
                                                Your browser does not support the audio tag.
                                    </audio>*/}

                                    <div className="div-main-control">
                                        <ButtonGroup onClick={this.toggleViewAudioVideoSettings} variant="contained"
                                            aria-label="outlined primary button group"
                                            className="button-group btn-main-control">
                                            <Button
                                                variant="text" className="btn-main"
                                                color="secondary">{t('easy-call-me.back')}</Button>
                                        </ButtonGroup>
                                    </div>
                                </>}

                                {!EasyCallMeState?.showAudioVideoSettings && <>
                                    {
                                        (AppState.withStyle && AppState.accessPageLogo) &&
                                        <div className="header-logo">
                                            <img className={'logo'} src={AppState.accessPageLogo} />
                                        </div>
                                    }
                                    <h3 className={'description'}>{t('easy-call-me.access_page_desc')}</h3>                                    {
                                        (AppState.withStyle) ?
                                            <>
                                                <div className="div-main-control">
                                                    <div className={'left-side'}>
                                                        <ButtonGroup variant="contained"
                                                            aria-label="outlined primary button group"
                                                            className="button-group btn-main-control no-border">
                                                            <input type="text" className="form-control"
                                                                placeholder={t('easy-call-me.name')}
                                                                onChange={event => this.onChange(event, 'name')}
                                                                value={EasyCallMeState?.name}
                                                            />
                                                        </ButtonGroup>
                                                        {
                                                            EasyCallMeState?.errorName &&
                                                            <p className="error">{t('easy-call-me.errors.name')}</p>
                                                        }
                                                    </div>
                                                    <div className={'right-side'}>
                                                        <ButtonGroup variant="contained"
                                                            aria-label="outlined primary button group"
                                                            className="button-group btn-main-control no-border">
                                                            <input type="text" className="form-control"
                                                                placeholder={t('easy-call-me.lastname')}
                                                                onChange={event => this.onChange(event, 'lastName')}
                                                                value={EasyCallMeState?.lastName}
                                                            />
                                                        </ButtonGroup>
                                                        {
                                                            EasyCallMeState?.errorLastName &&
                                                            <p className="error">{t('easy-call-me.errors.lastname')}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="div-main-control">
                                                    <ButtonGroup variant="contained"
                                                        aria-label="outlined primary button group"
                                                        className="button-group btn-main-control no-border">
                                                        <input type="text" className="form-control"
                                                            placeholder={t('easy-call-me.email')}
                                                            onChange={event => this.onChange(event, 'email')}
                                                            value={EasyCallMeState?.email}
                                                        />
                                                    </ButtonGroup>
                                                    {
                                                        EasyCallMeState?.errorEmail &&
                                                        <p className="error">{t('easy-call-me.errors.email')}</p>
                                                    }
                                                </div>
                                                <div className="div-main-control" style={{ paddingTop: '5px' }}>
                                                    <ButtonGroup variant="contained"
                                                        aria-label="outlined primary button group"
                                                        className="button-group btn-main-control">
                                                        <Button
                                                            onClick={() => {
                                                                this.enter();
                                                            }}
                                                            // disabled={!selectedMic || !AppState.userAgent || AppState.userAgentState !== UserAgentState.Started}
                                                            variant="contained"
                                                            className="btn-main">{t('enter')}</Button>
                                                    </ButtonGroup>
                                                </div>
                                                {/*<div className="div-main-control">
                                        <ButtonGroup variant="contained" aria-label="outlined primary button group"
                                                     className="button-group btn-main-control">
                                            <Button
                                                startIcon={<SettingsIcon/>}
                                                variant="outlined" color="secondary" className="btn-main"
                                                onClick={this.toggleViewAudioVideoSettings}>{t('easy-call-me.audio_video_settings')}</Button>
                                        </ButtonGroup>
                                    </div>*/}
                                            </> :
                                            <>
                                                <div className="div-main-control">
                                                    <ButtonGroup variant="contained"
                                                        aria-label="outlined primary button group"
                                                        className="button-group btn-main-control no-border">
                                                        <TextField id="filled-basic" label={t('easy-call-me.name')}
                                                            variant="standard" size={'medium'} fullWidth
                                                            onChange={event => this.onChange(event, 'name')}
                                                            value={EasyCallMeState?.name}
                                                        />
                                                    </ButtonGroup>
                                                    {
                                                        EasyCallMeState?.errorName &&
                                                        <p className="error">{t('easy-call-me.errors.name')}</p>
                                                    }
                                                </div>
                                                <div className="div-main-control">
                                                    <ButtonGroup variant="contained"
                                                        aria-label="outlined primary button group"
                                                        className="button-group btn-main-control no-border">
                                                        <TextField id="filled-basic"
                                                            label={t('easy-call-me.lastname')}
                                                            variant="standard" size={'medium'} fullWidth
                                                            onChange={event => this.onChange(event, 'lastName')}
                                                            value={EasyCallMeState?.lastName}
                                                        />
                                                    </ButtonGroup>
                                                    {
                                                        EasyCallMeState?.errorLastName &&
                                                        <p className="error">{t('easy-call-me.errors.lastname')}</p>
                                                    }
                                                </div>
                                                <div className="div-main-control">
                                                    <ButtonGroup variant="contained"
                                                        aria-label="outlined primary button group"
                                                        className="button-group btn-main-control no-border">
                                                        <TextField id="filled-basic" label={t('easy-call-me.email')}
                                                            variant="standard" size={'medium'} fullWidth
                                                            onChange={event => this.onChange(event, 'email')}
                                                            value={EasyCallMeState?.email}
                                                        />
                                                    </ButtonGroup>
                                                    {
                                                        EasyCallMeState?.errorEmail &&
                                                        <p className="error">{t('easy-call-me.errors.email')}</p>
                                                    }
                                                </div>
                                                <br />
                                                <div className="div-main-control">
                                                    <ButtonGroup variant="contained"
                                                        aria-label="outlined primary button group"
                                                        className="button-group btn-main-control">
                                                        <Button
                                                            onClick={() => {
                                                                this.enter();
                                                            }}
                                                            // disabled={!selectedMic || !AppState.userAgent || AppState.userAgentState !== UserAgentState.Started}
                                                            variant="contained"
                                                            className="btn-main">{t('enter')}</Button>
                                                    </ButtonGroup>
                                                </div>
                                                {/*<div className="div-main-control">
                                        <ButtonGroup variant="contained" aria-label="outlined primary button group"
                                                     className="button-group btn-main-control">
                                            <Button
                                                startIcon={<SettingsIcon/>}
                                                variant="outlined" color="secondary" className="btn-main"
                                                onClick={this.toggleViewAudioVideoSettings}>{t('easy-call-me.audio_video_settings')}</Button>
                                        </ButtonGroup>
                                    </div>*/}
                                            </>
                                    }
                                </>}
                            </div>
                        </Grid>
                    </Grid>
                    <div className={'footer-text'}>
                        {t('easy-call-me.access_page_footer_text', { "current-year": (new Date()).getFullYear().toString() })}
                    </div>
                </div>
            </>
        );
    }

    componentDidMount() {
        const AppComp: App = this.props.AppComp;
        const AppState: InterfaceAppState = this.props.AppState;

        AppComp.initPreviewVideo();

        /*
                this.observer = new ResizeObserver(entries => {
                    if (entries[0].contentRect.width < 900) {
                        if (!this.state.smallMode) {
                            this.setState({
                                smallMode: true
                            }, () => {
                                AppComp.initPreviewVideo();
                            });
                        }
                    } else {
                        if (this.state.smallMode) {
                            this.setState({
                                smallMode: false
                            }, () => {
                                AppComp.initPreviewVideo();
                            });
                        }
                    }
                });
        */

        /*const el = document.getElementById('pre-call-form-container');
        if (el) {
            this.observer.observe(el);
        }*/
    }

    componentWillUnmount() {
        /*
                this.observer?.disconnect();
                this.observer = null;
        */
    }

    toggleViewAudioVideoSettings = () => {
        const AppComp: App = this.props.AppComp;
        const EasyCallMeState: InterfaceEasyCallMeState = this.props.AppState.EasyCallMe;

        EasyCallMeState.showAudioVideoSettings = !EasyCallMeState.showAudioVideoSettings;
        AppComp.setState({
            EasyCallMe: EasyCallMeState
        })
    }

    onChange = (e: ChangeEvent, what: 'name' | 'lastName' | 'email') => {
        const AppComp: App = this.props.AppComp;
        const EasyCallMeState: InterfaceEasyCallMeState = this.props.AppState.EasyCallMe;

        // @ts-ignore
        EasyCallMeState[what] = e.target.value;

        AppComp.setState({
            EasyCallMe: EasyCallMeState
        });
    }

    enter = () => {
        const EasyCallMeState: InterfaceEasyCallMeState = this.props.AppState.EasyCallMe;

        this.validateAndCall(() => {
            if (EasyCallMeState.api_url && EasyCallMeState.api_url.trim().length > 0) {
                this.fetchToCall();
            } else {
                this.redirectToCall();
            }
        });
    }

    validateAndCall = (validCallback: Function) => {
        const AppComp: App = this.props.AppComp;
        const EasyCallMeState: InterfaceEasyCallMeState = this.props.AppState.EasyCallMe;

        let name = EasyCallMeState.name.trim();
        EasyCallMeState.errorName = !ValidateUtil.isValidName(name);

        let lastName = EasyCallMeState.lastName.trim();
        EasyCallMeState.errorLastName = !ValidateUtil.isValidName(lastName);

        let email = EasyCallMeState.email.trim().toLowerCase();
        EasyCallMeState.errorEmail = !ValidateUtil.isValidEmail(email);

        AppComp.setState({
            EasyCallMe: EasyCallMeState
        });

        if (!EasyCallMeState.errorName &&
            !EasyCallMeState.errorLastName &&
            !EasyCallMeState.errorEmail) {
            validCallback();
        }
    }

    fetchToCall = () => {
        const AppComp: App = this.props.AppComp;
        const EasyCallMeState: InterfaceEasyCallMeState = this.props.AppState.EasyCallMe;

        // name=Mario Rossi&email=mario.rossi@rossi.it&call=500&color=%23e2111a&mode=api
        const url = new URL(EasyCallMeState.api_url);
        const queries = url.searchParams;
        queries.set('name', EasyCallMeState.name + ' ' + EasyCallMeState.lastName);
        queries.set('email', EasyCallMeState.email);
        queries.set('call', (window as any)._easy_link_config.call_destination);
        queries.set('color', (window as any)._easy_link_config.main_color);
        queries.set('mode', 'api');

        url.search = queries.toString();

        const urlString = url.toString();

        fetch(urlString).then(res => res.json()).then((json: any) => {
            if (json && json.status && json.data) {
                const mode = (window as any)._easy_link_config.mode;

                (window as any)._easy_link_config = json.data;
                (window as any)._easy_link_config.step = 'call';
                (window as any)._easy_link_config.mode = mode;

                AppComp.init(false, () => {
                    AppComp.afterViewMounted();
                });
            } else {
                AppComp.setState({
                    catched: {
                        error: new Error(i18next.t('something_went_wrong')),
                        retry: false,
                        retryTitle: '',
                        retryFunc: () => {
                        }
                    }
                });
            }
        }).catch((error) => {
            AppComp.setState({
                catched: {
                    error: new Error(i18next.t('something_went_wrong')),
                    retry: false,
                    retryTitle: '',
                    retryFunc: () => {
                    }
                }
            });
        });
    }

    redirectToCall = () => {
        const EasyCallMeState: InterfaceEasyCallMeState = this.props.AppState.EasyCallMe;

        const url = new URL(EasyCallMeState.next_url);
        const queries = url.searchParams;
        queries.set('name', EasyCallMeState.name + ' ' + EasyCallMeState.lastName);
        queries.set('email', EasyCallMeState.email);

        url.search = queries.toString();

        window.location.href = url.toString();
    }
}

export default withTranslation()(EasyCallMeComp);
